import React, { memo, useState, useEffect, useCallback } from 'react'
import styles from './ProductsPage.module.scss'
import { useNavigate } from 'react-router-dom'
import ProductCard from '../components/ProductCard'
import CommonPagination from '../../../common/components/pagination/CommonPagination'
import { SolarProduct } from '../../../model/solar-product/solar-product'
import solarProductService from '../../../httpService/SolarProductService'
import { toast } from 'react-toastify'
import CommonLoadingSpinnerForPage from '../../../common/components/loading-spinner/CommonLoadingSpinnerForPage'
import { ApplicationRoutes } from '../../../routes'
import { useDispatch } from 'react-redux'
import { submitFirstStep } from '../../../stores/slices/solar-product-details-slice'

type Props = {}

const ProductsPage: React.FC<Props> = memo((props: Props) => {
    const [products, setProducts] = useState<SolarProduct[]>([])
    const [loading, setLoading] = useState(false)

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const pageSize = 6;

    const navigator = useNavigate();
    const dispatch = useDispatch()

    function handleAddProduct() {
        dispatch(submitFirstStep({}));
        navigator(`${ApplicationRoutes.PROVIDER_BASE}/${ApplicationRoutes.CREATE_PRODUCT}`)
    }

    const fetchProducts = useCallback(
        async () => {
            try {
                let productsMapped: SolarProduct[] = [];

                setLoading(true);

                const response = await solarProductService.getPaged(currentPage, pageSize);

                response.data.items.map((item: any) => productsMapped.push(new SolarProduct({
                    ...item,
                })))

                setTotalPages(response.data.totalPages);
                setProducts(productsMapped);
            } catch (error) {
                toast.error("There was an error fetching products")
            } finally {
                setLoading(false);
            }
        },
        [currentPage],
    )

    useEffect(() => {
        fetchProducts();
    }, [fetchProducts])

    return (
        <CommonLoadingSpinnerForPage loading={loading}>
            {
                products.length > 0 ? <div className={styles.cardsContainer}>
                    <div className={styles.cardsHeader}>
                        <button
                            className={`standardButton ${styles.createNewProductButton}`}
                            onClick={handleAddProduct} >
                            Create New Product
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.37565 8.62463V11.333C7.37565 11.5101 7.43557 11.6585 7.5554 11.7783C7.67525 11.8981 7.82375 11.958 8.0009 11.958C8.17807 11.958 8.32648 11.8981 8.44613 11.7783C8.56578 11.6585 8.62561 11.5101 8.62561 11.333V8.62463H11.334C11.511 8.62463 11.6595 8.56472 11.7793 8.44488C11.8991 8.32504 11.9589 8.17654 11.9589 7.99938C11.9589 7.82222 11.8991 7.67381 11.7793 7.55415C11.6595 7.4345 11.511 7.37468 11.334 7.37468H8.62561V4.66632C8.62561 4.48924 8.56569 4.3408 8.44586 4.22101C8.32601 4.10123 8.17751 4.04134 8.00036 4.04134C7.82319 4.04134 7.67478 4.10123 7.55513 4.22101C7.43548 4.3408 7.37565 4.48924 7.37565 4.66632V7.37468H4.6673C4.49021 7.37468 4.34178 7.43459 4.22201 7.55443C4.10221 7.67427 4.04232 7.82277 4.04232 7.99993C4.04232 8.17709 4.10221 8.3255 4.22201 8.44516C4.34178 8.56481 4.49021 8.62463 4.6673 8.62463H7.37565ZM8.00203 15.9163C6.90708 15.9163 5.87789 15.7085 4.91444 15.293C3.95098 14.8774 3.11292 14.3135 2.40023 13.6011C1.68754 12.8887 1.12332 12.051 0.707589 11.088C0.291853 10.125 0.0839844 9.09599 0.0839844 8.00105C0.0839844 6.90611 0.291762 5.87691 0.707318 4.91347C1.12287 3.95001 1.68683 3.11194 2.39919 2.39926C3.11157 1.68656 3.94927 1.12235 4.9123 0.706613C5.87531 0.290877 6.90429 0.0830078 7.99924 0.0830078C9.09418 0.0830078 10.1234 0.290787 11.0868 0.706342C12.0503 1.1219 12.8883 1.68586 13.601 2.39822C14.3137 3.11059 14.8779 3.94829 15.2937 4.91132C15.7094 5.87434 15.9173 6.90331 15.9173 7.99826C15.9173 9.0932 15.7095 10.1224 15.2939 11.0858C14.8784 12.0493 14.3144 12.8874 13.6021 13.6001C12.8897 14.3127 12.052 14.877 11.089 15.2927C10.126 15.7084 9.09697 15.9163 8.00203 15.9163ZM8.00063 14.6663C9.86174 14.6663 11.4381 14.0205 12.7298 12.7288C14.0215 11.4372 14.6673 9.86077 14.6673 7.99965C14.6673 6.13854 14.0215 4.56215 12.7298 3.27049C11.4381 1.97882 9.86174 1.33299 8.00063 1.33299C6.13952 1.33299 4.56313 1.97882 3.27146 3.27049C1.9798 4.56215 1.33396 6.13854 1.33396 7.99965C1.33396 9.86077 1.9798 11.4372 3.27146 12.7288C4.56313 14.0205 6.13952 14.6663 8.00063 14.6663Z" fill="#1C1B1F" />
                            </svg>
                        </button>
                    </div>
                    <div className={styles.cards}>
                        {products.map((product: SolarProduct, index: number) => {
                            return (
                                <ProductCard key={index} product={product} showMenu triggerLoad={fetchProducts} />
                            )
                        })}
                    </div>
                    <div className={styles.paginationContainer}>
                        <CommonPagination currentPage={currentPage} numberOfPages={totalPages} onPageChange={(page: number) => {
                            setCurrentPage(page)
                        }} />
                    </div>
                </div> : <div className={styles.emptyContainer}>
                    <div className={styles.imageContainer}>
                        <svg width="31" height="25" viewBox="0 0 31 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.86979 24.5C2.95599 24.5 2.17372 24.2389 1.52298 23.7167C0.872244 23.1944 0.546875 22.5667 0.546875 21.8333V16.5C0.546875 15.7667 0.872244 15.1389 1.52298 14.6167C2.17372 14.0944 2.95599 13.8333 3.86979 13.8333H27.1302C28.044 13.8333 28.8263 14.0944 29.477 14.6167C30.1278 15.1389 30.4531 15.7667 30.4531 16.5V21.8333C30.4531 22.5667 30.1278 23.1944 29.477 23.7167C28.8263 24.2389 28.044 24.5 27.1302 24.5H3.86979ZM3.86979 11.1667C2.95599 11.1667 2.17372 10.9056 1.52298 10.3833C0.872244 9.86111 0.546875 9.23333 0.546875 8.5V3.16667C0.546875 2.43333 0.872244 1.80556 1.52298 1.28333C2.17372 0.761111 2.95599 0.5 3.86979 0.5H27.1302C28.044 0.5 28.8263 0.761111 29.477 1.28333C30.1278 1.80556 30.4531 2.43333 30.4531 3.16667V8.5C30.4531 9.23333 30.1278 9.86111 29.477 10.3833C28.8263 10.9056 28.044 11.1667 27.1302 11.1667H3.86979ZM27.1302 3.16667H3.86979V8.5H27.1302V3.16667ZM27.1302 8.5H3.86979V3.16667H27.1302V8.5Z" fill="#7F7D82" />
                        </svg>
                    </div>
                    <div className={styles.text}>
                        No Product added yet
                    </div>
                    <button className={`standardButton ${styles.button}`} onClick={handleAddProduct}>
                        Add Product
                        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.3335 6.16634H8.3335V1.16634C8.3335 0.945327 8.2457 0.733366 8.08942 0.577086C7.93314 0.420805 7.72118 0.333008 7.50016 0.333008C7.27915 0.333008 7.06719 0.420805 6.91091 0.577086C6.75463 0.733366 6.66683 0.945327 6.66683 1.16634V6.16634H1.66683C1.44582 6.16634 1.23385 6.25414 1.07757 6.41042C0.921294 6.5667 0.833496 6.77866 0.833496 6.99967C0.833496 7.22069 0.921294 7.43265 1.07757 7.58893C1.23385 7.74521 1.44582 7.83301 1.66683 7.83301H6.66683V12.833C6.66683 13.054 6.75463 13.266 6.91091 13.4223C7.06719 13.5785 7.27915 13.6663 7.50016 13.6663C7.72118 13.6663 7.93314 13.5785 8.08942 13.4223C8.2457 13.266 8.3335 13.054 8.3335 12.833V7.83301H13.3335C13.5545 7.83301 13.7665 7.74521 13.9228 7.58893C14.079 7.43265 14.1668 7.22069 14.1668 6.99967C14.1668 6.77866 14.079 6.5667 13.9228 6.41042C13.7665 6.25414 13.5545 6.16634 13.3335 6.16634Z" fill="#2E3336" />
                        </svg>
                    </button>
                </div>
            }
        </CommonLoadingSpinnerForPage>

    )
})

export default ProductsPage